/* eslint-disable camelcase */
export enum ParcelamentoTypes {
  GET_PARCELAMENTO_REQUEST = '@parcelamento/GET_PARCELA_REQUEST',
  GET_PARCELAMENTO_SUCCESS = '@parcelamento/GET_PARCELAMENTO_SUCCESS',
  GET_PARCELAMENTO_FAILURE = '@parcelamento/GET_PARCELAMENTO_FAILURE',
}
export interface ServicesDadosTypes {
  id: number;
  nome: string;
  descricao: string;
  valor_servico: string;
  valor: string;
  valor_adicional: number;
  status_id: number;
  plano: string;
  quantidade: string;
  valor_unitario: string;
}
export interface ParcelaServiceTypes {
  total_maximo_parcelas: number;
  valor_base: string;
  valor_adicional: number;
  servicos: Array<ServicesDadosTypes>;
  valor_negociacao: number;
  valor_variacao_forma_pagamento: string;
  valor_final: number;
  valor_parcela: string;
  parcelas: object;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface ParcelamentoServicesState {
  parcelamento: ParcelaServiceTypes;
  readonly requestParcelamento: RequestState;
}
